import React, { useRef, useEffect, useLayoutEffect } from 'react';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Card from 'src/components/common/Card.redesign';
import LeaseGenerationTractDetail from 'src/models/leasing/LeaseGenerationTractDetail';
import { TweenLite } from 'gsap';

interface IRunsheetTractListProps {
    tracts?: Array<LeaseGenerationTractDetail>;
    clientNumber: number;
    projectNumber: number;
    selectedTractIds: Array<number>;
    navigateToTractDetail?: (tractId: number) => void;
    updateSelectedTractIds: (tractId: number) => void;
}

const RunsheetTractList = (props: IRunsheetTractListProps) => {
    const legDescEl = useRef([]);

    useEffect(() => {
        truncateLegalDescriptions();
    }, [props.tracts]);

    useLayoutEffect(() => {
        truncateLegalDescriptions();
    }, []);

    const getWrapInfo = (element: HTMLElement): DOMRect[] => {
        const range = document.createRange();
        range.selectNodeContents(element);
        const rects = range.getClientRects();
        if (!!rects && rects.length > 1) {
/*         const longestLine = Array.from(rects).reduce((rect: DOMRect, line) => {
            return (rect.width > line.width) ? rect : line;
          }, new DOMRect()); */

/*         const sum = Array.from(rects).reduce((accumulator, object) => {
            return accumulator + object.width;
        }, 0); */

        // const averageLength = sum / rects.length;
        // return {averageLineLength: averageLength, lines: rects.length, total: sum, firstTwo: rects[0].width + rects[1].width};
        return Array.from(rects);
    } else {
        // return {averageLineLength: 0, lines: rects.length, total: 0, firstTwo: 0};
        return [];
    }
    };

    const getStringWidth = (text: string, font: string) => {
        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        context.font = font;
        const metrics = context.measureText(text);
        return metrics.width;
      };

    const truncateLegalDescriptions = () => {
        if (!!props?.tracts && props?.tracts?.length > 0) {
            props.tracts.forEach((tract, index: number) => {
                console.log(tract?.id);
                let ldElement = document.getElementById(`legalDescriptionDiv${index}`);
                if (!!ldElement) {
                    const wrapInfo = getWrapInfo(ldElement);
                    const stringWidth = getStringWidth(ldElement.innerText, '12px Arial');
                    if (wrapInfo.length <= 2) {
                        // noop - do nothing because the legal description is only on one line already
                    } else {
                        const scalingFactor = ldElement.innerText.length / stringWidth;
                        const newStrlen = (wrapInfo[0].width + wrapInfo[1].width) * scalingFactor;
                        ldElement.innerText = ldElement.innerText.substring(0, (Math.round(newStrlen)) - 3);
                        ldElement.innerText += '...';
                    }
                    // const scalingFactor = ldElement.innerText.length / wraps.firstTwo;
/*                     if (wraps.lines > 2) {
                        ldElement.innerText = ldElement.innerText.substring(0, (Math.round(ldElement.innerText.length * scalingFactor * 2)) - 3);
                        ldElement.innerText += '...';
                    } */
                }
            });
        }
    };

    const toggleLegalDesc = (state: boolean, index: number, clientX: number, clientY: number) => {
        if (state) {
            TweenLite.set(
                legDescEl.current[index],
                { top: `${clientY}`, left: `${clientX - 375}`, width: '500px', height: 'auto', position: 'fixed', display: 'inline-block', background: 'white', borderColor: '#6393C1', zIndex: 100 }
            );
        } else {
            TweenLite.to(legDescEl.current[index], 0.2, { height: '2.5rem', display: 'none', background: 'transparent', borderColor: 'transparent', zIndex: 0 });
        }
    };

    return (
        <CardContainer className="owner-tracts-results">
            {props?.tracts && props?.tracts?.length &&
                props.tracts.map((x: LeaseGenerationTractDetail, index) => {
                    return (
                        <>
                            <span
                                ref={el => legDescEl.current[index] = el}
                                style={{
                                    borderRadius: '5px',
                                    display: 'none',
                                    overflow: 'hidden',
                                    position: 'absolute',
                                    border: '2px solid transparent',
                                    padding: '.3rem',
                                    background: 'transparent',
                                    borderColor: 'transparent',
                                    zIndex: 100,
                                    height: 'auto',
                                }}
                            >
                            {x?.legalDescription}
                            </span>
                        <Card
                            actionPanelStyle={{transform: 'translateY(-1rem) rotate(90deg)'}}
                            rightBadgePanelstyle={{ transform: 'translateX(-35px)', background: '#dddcdc', fontSize: '11.5px', display: 'flex', whiteSpace: 'nowrap' }}
                            collapse={true}
                            key={`${index} ${x?.id}`}
                            badge={`${x?.sectionNumber}` + '.' + `${x?.tractNumber} - ${x?.tractName}`}
                            onClick={() => props.updateSelectedTractIds(x?.id)}
                            className={props.selectedTractIds.includes(x?.id) ? 'selected spaced' : 'spaced'}
                            newContext={false}
                            showMenu={true}
                            rightBadgePanel={`${x?.grossAcres?.toFixed(2)} ac., in ${x?.county?.name} Co.`}
                            actions={[{ text: 'Tract Detail', action: () => props.navigateToTractDetail(x.id) }]}
                        >
                            <div style={{ margin: '.2rem' }}>
                                <div style={{ display: 'flex' }}>
                                    {/*<div style={{ marginRight: '1rem' }}>Legal:</div>*/}
                                        <span
                                            onMouseOver={(e) => toggleLegalDesc(true, index, e.clientX, e.clientY)}
                                            onMouseOut={() => toggleLegalDesc(false, index, 0, 0)}
                                            style={{ overflow: 'hidden', display: 'flex', whiteSpace: 'nowrap' }}
                                        >
                                            <div style={{fontSize: '20px', paddingRight: '20px'}}>👁‍🗨</div>
                                        </span>

                                    <div id={`legalDescriptionDiv${index}`} style={{ fontSize: '12px', marginRight: '1rem' }}> {x?.legalDescription}</div>
                                </div>
                                {/*<div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Name:</div>
                                    <div className="owner-tract-legal-description">{x.tractName}</div>
                                </div>
                            </div>
                            <div style={{ margin: '.2rem', display: 'flex', justifyContent: 'space-between', borderTop: '1px solid lightgrey' }}>
                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Gross:</div>
                                    <div>{x.grossAcres}</div>
                                </div>

                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Interest:</div>
                                    <div>{x.decimalInterest}</div>
                                </div>

                                <div style={{ display: 'flex' }}>
                                    <div style={{ marginRight: '1rem' }}>Net:</div>
                                    <div>{x.grossAcres * x.decimalInterest}</div>
                                </div>
                                */}
                            </div>
                        </Card>
                        </>
                    );
                })}
            {props.tracts && props.tracts?.length === 0 && <div>No Tracts for this Project</div>}
            {/* SurfaceOwnerships */}
        </CardContainer>
    );
};

export default RunsheetTractList;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/RunsheetTractList.tsx